
import React from 'react';
import { BackArrowButton } from './Common';

// Shared BackArrowButton on the steps back to sit at top of the BeigeTile
export const TileBackArrow = ({ onClick }) => (
  <BackArrowButton style={{ marginTop: '-20px', marginBottom: '20px' }} onClick={onClick} />
)